import { Pagination } from '@mantine/core'
import * as XLSX from 'xlsx'
import React, { useMemo, useState } from 'react'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import List from '../common/List'
import SaveButton from '../common/SaveButton'
import MantineSelectBox from '../common/MantineSelectBox'
import { Select, Modal } from '@mantine/core'
import { useEffect } from 'react'
import { apiRequest } from '../../utils/api'
import { buildMonthlyReportPages } from '../../utils/reportPdfBuilder'
import '../../styles/admin/users-box.css'
import { Icon } from '../../assets/icons'
import { notifications } from '@mantine/notifications'
import { modals } from '@mantine/modals'
import { useUsersUpdate } from '../../api/hooks/Users/useUsersUpdate'
import { useUsersDelete } from '../../api/hooks/Users/useUsersDelete'
import styles from '../../styles/admin/Main.module.scss'
import { useAuthStore } from '../../store'
import BaseButton from '../common/BaseButton'
import AddUserModal from '../manager/AddUserModal'
import PayPalCheckout from '../../utils/PayPalCheckout'
import { Button } from '@mantine/core'
import GuardianInfoModal from '../manager/GuardianInfoModal'
import GuardianEditModal from '../manager/GuardianEditModal'

const LADDER = [
  { upto: 9, price: 18 }, // 1~9
  { upto: 29, price: 14 }, // 10~29
  { upto: 49, price: 12 }, // 30~49
  { upto: Infinity, price: 10 }, // 50+
]

// 총 N명일 때의 누적 금액 (표와 동일)
function calcTotalForCount(totalSeats, ladder = LADDER) {
  if (totalSeats <= 0) return 0
  let remaining = totalSeats
  let acc = 0
  let cursor = 0

  for (const tier of ladder) {
    if (remaining <= 0) break
    const tierStart = cursor + 1
    const tierEnd = Number.isFinite(tier.upto) ? tier.upto : cursor + remaining
    const seatsInThisTier = Math.min(remaining, tierEnd - tierStart + 1)
    if (seatsInThisTier > 0) {
      acc += seatsInThisTier * tier.price
      remaining -= seatsInThisTier
      cursor += seatsInThisTier
    }
  }
  return Number(acc.toFixed(2))
}

// 현재 인원에서 seatsToAdd명 추가 결제 시 “추가분” 금액
function calcDeltaFromCurrent(currentSeats, seatsToAdd, ladder = LADDER) {
  const before = calcTotalForCount(currentSeats, ladder)
  const after = calcTotalForCount(currentSeats + seatsToAdd, ladder)
  return Number((after - before).toFixed(2))
}

const SORTABLE_COLS = [
  { label: 'No',        field: null },
  { label: 'Name',      field: 'NAME' },
  { label: 'Phone',     field: 'PHONE' },
  { label: 'Center',    field: 'CENTER' },
  { label: 'Subscribe', field: 'SUB' },
  { label: 'Role',      field: 'ROLE' },
  { label: 'Status',    field: 'STATE' },
  { label: 'Level',     field: 'LEVEL' },
  { label: 'Date',      field: 'DATE' },
]

const UsersBox = () => {
  const user = useAuthStore((state) => state.user)
  const [sortConfig, setSortConfig] = React.useState({ field: null, dir: 'asc' })
  const usersColumnWidths = [
    '5%',
    '20%',
    '15%',
    '15%',
    '10%',
    '10%',
    '5%',
    '10%',
    '10%',
  ]
  const defaultUserForm = {
    USER_ID: '',
    NAME: '',
    PASSWORD: '',
    EMAIL: '',
    PHONE: '',
    BIRTH: '',
    ADDR: '',
    POSTCODE: '',
    CITY: '',
    COUNTRY: '',
    SCHOOL: '',
    LEVEL: '',
    LEVEL_ID: '',
    CENTER_ID: '',
    CENTER_NAME: '',
    PARENT_ID: '',
    GUARDIAN_NAME: '',
    GUARDIAN_EMAIL: '',
    STATE: 'Y',
    AVATAR: '',
    TEST: '',
    REFERRER_ID: '',
  }
  const {
    mutate: updateUser,
    isLoading: isUpdating,
    isSuccess,
    isError,
    reset,
  } = useUsersUpdate()
  const { mutate: deleteUser, isLoading: isDeleting } = useUsersDelete()

  const [usersList, setUsersList] = useState([])
  const [detailUsersList, setDetailUsersList] = useState([])
  const [countries, setCountries] = useState([])
  const [CENTER_DATA, setCENTER_DATA] = useState([])

  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [editForm, setEditForm] = useState(defaultUserForm)

  const [CENTER_NAME, setCENTER_NAME] = useState('')
  const [NAME, setNAME] = useState('')
  const [PHONE, setPHONE] = useState('')
  const [STATE, setSTATE] = useState('')

  const [isPaying, setIsPaying] = useState(false)
  const [isSubModalOpen, setIsSubModalOpen] = useState(false) // 월/년 선택 모달
  const [showPayPalSub, setShowPayPalSub] = useState(false) // PayPal 오버레이
  const [subCycle, setSubCycle] = useState('M') // 'M' or 'Y'
  const [pendingTargets, setPendingTargets] = useState([]) // 결제 대상 (SUB='N')
  const [totalUser, setTotalUser] = useState([]) // 결제 대상 (SUB='N')

  const [isGuardianModalOpen, setGuardianModalOpen] = useState(false)
  const [isGuardianEditModalOpen, setGuardianEditModalOpen] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)
  const [reportSavedAt, setReportSavedAt] = useState(null)
  const [chapterMap, setChapterMap] = useState({})
  const defaultReportMonth = (() => {
    const d = new Date()
    d.setMonth(d.getMonth() - 1)
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
  })()
  const [reportMonth, setReportMonth] = useState(defaultReportMonth)
  const [chapterOrder, setChapterOrder] = useState([])
// Report generation helpers
const getUiStageStats = (stats) => {
  const uiStages = stats.slice(0, 4)
  return uiStages.map((s, index) => ({
    ...s,
    stage: stageMap[index],
  }))
}

// LEVEL_FOCUS_MAP은 기존에 정의되어 있어야 합니다. 없으면 빈 객체로 대체
const LEVEL_FOCUS_MAP = typeof window !== "undefined" && window.LEVEL_FOCUS_MAP ? window.LEVEL_FOCUS_MAP : {};

const getLevelMeta = (student) => {
  const key = String(student?.LEVEL || '').toLowerCase()
  const mapped = LEVEL_FOCUS_MAP[key]

  const levelIdRaw = String(student?.LEVEL_ID || '')
  const chapterFromMap = chapterMap[levelIdRaw]
  const chapter = student?.CHAPTER || chapterFromMap || ''

  const formatLevelCode = (value) => {
    const raw = String(value || '').trim()
    if (!raw) return ''
    if (raw.includes('-')) return raw
    return raw.split('').filter(Boolean).join('-')
  }

  const levelCode = formatLevelCode(levelIdRaw)

  // fallback용 (CHAPTER 없을 때만 사용)
  const digits = levelIdRaw.split('')

  const hierarchy = {
    major: digits[0] || '',
    middle: digits[1] || '',
    sub: digits[2] || '',
    detail: digits[3] || '',
    lesson: digits[4] || '',
  }

  // fallback label
  const fallbackLabel = levelIdRaw
    ? `Unit ${hierarchy.major} > Topic ${hierarchy.middle} > Concept ${hierarchy.sub} > Detail ${hierarchy.detail}${hierarchy.lesson ? ` > Lesson ${hierarchy.lesson}` : ''}`
    : ''

  // 🔥 핵심: CHAPTER 우선
  const progressLabel = chapter || fallbackLabel

  if (mapped) {
    return {
      ...mapped,
      levelId: levelIdRaw,
      levelCode,
      progressLabel,
      hierarchy,
      test: student?.TEST || '',
    }
  }

  return {
    level: student?.LEVEL || 'Unknown Level',
    focus: 'Current Topic In Progress',
    description:
      'The student is currently progressing through the curriculum and building mathematical understanding step by step.',
    levelId: levelIdRaw,
    levelCode,
    progressLabel,
    hierarchy,
    test: student?.TEST || '',
  }
}

const getLearningDayFromLevelId = (levelId) => {
  const rawLevelId = String(levelId || '').trim()
  if (!rawLevelId || chapterOrder.length === 0) return ''

  const currentLevelPrefix = rawLevelId.charAt(0)
  const currentLevelOrder = chapterOrder.filter(
    (item) => String(item).trim().charAt(0) === currentLevelPrefix
  )

  const lessonIndex = currentLevelOrder.findIndex(
    (item) => String(item) === rawLevelId
  )

  if (lessonIndex === -1) return ''

  const lessonNumber = lessonIndex + 1
  const reviewDaysBefore = Math.floor((lessonNumber - 1) / 4)
  const learningDay = lessonNumber + reviewDaysBefore

  return `Day ${learningDay}`
}

const clampPercent = (value) => {
  const num = Number(value || 0)
  if (Number.isNaN(num)) return 0
  return Math.max(0, Math.min(100, Number(num.toFixed(1))))
}

const getStageDeltaPattern = (uiStageStats = []) => {
  const percents = uiStageStats.map((item) => clampPercent(item.percent))
  const deltas = percents.slice(1).map((value, index) => Number((value - percents[index]).toFixed(1)))
  const hasDrop = deltas.some((delta) => delta < 0)
  const biggestGain = deltas.length ? Math.max(...deltas) : 0
  const smallestGain = deltas.length ? Math.min(...deltas) : 0
  const isSteady = deltas.length > 0 && !hasDrop && biggestGain - smallestGain <= 8

  return {
    percents,
    deltas,
    hasDrop,
    biggestGain,
    smallestGain,
    isSteady,
  }
}

const buildInsightProfile = ({ student, uiStageStats, levelMeta }) => {
  const { percents, deltas, hasDrop, isSteady } = getStageDeltaPattern(uiStageStats)
  const first = clampPercent(percents[0])
  const mastery = clampPercent(percents[percents.length - 1])
  const improvement = Number((mastery - first).toFixed(1))
  const currentFocus = levelMeta?.progressLabel || levelMeta?.focus || 'the current topic'
  const currentFocusLower = currentFocus.toLowerCase()

  let achievementBand = 'low'
  if (mastery >= 90) achievementBand = 'high'
  else if (mastery >= 75) achievementBand = 'medium'

  let growthBand = 'low'
  if (improvement >= 20) growthBand = 'strong'
  else if (improvement >= 8) growthBand = 'moderate'

  let patternType = 'developing'
  if (first >= 85 && mastery >= 90) patternType = 'fast-accurate'
  else if (first < 70 && mastery >= 85) patternType = 'review-driven'
  else if (first >= 70 && mastery < 85) patternType = 'accuracy-building'
  else if (hasDrop) patternType = 'variable-progress'

  let supportLevel = 'high'
  if (mastery >= 90 && improvement >= 10) supportLevel = 'low'
  else if (mastery >= 75 || improvement >= 8) supportLevel = 'medium'

  let recommendationTheme = 'general-review'
  if (currentFocusLower.includes('fraction')) recommendationTheme = 'fractions'
  else if (currentFocusLower.includes('decimal')) recommendationTheme = 'decimals'
  else if (
    currentFocusLower.includes('equal') ||
    currentFocusLower.includes('divide') ||
    currentFocusLower.includes('pieces') ||
    currentFocusLower.includes('group')
  ) {
    recommendationTheme = 'equal-division'
  } else if (
    currentFocusLower.includes('place value') ||
    currentFocusLower.includes('digit') ||
    currentFocusLower.includes('number')
  ) {
    recommendationTheme = 'place-value'
  }

  return {
    studentName: student?.NAME || 'The student',
    first,
    mastery,
    improvement,
    currentFocus,
    achievementBand,
    growthBand,
    patternType,
    supportLevel,
    recommendationTheme,
    hasDrop,
    isSteady,
    deltas,
  }
}

const getLearningType = (profile) => {
  if (profile.patternType === 'fast-accurate') {
    return {
      title: 'Strong Initial Understanding',
      message: 'The student quickly understands new concepts and maintains strong accuracy from the beginning.',
    }
  }

  if (profile.patternType === 'review-driven') {
    return {
      title: 'Learns Well Through Review',
      message: 'The student may need time at first, but repeated practice leads to strong understanding and better accuracy.',
    }
  }

  if (profile.patternType === 'accuracy-building') {
    return {
      title: 'Conceptually Engaged Learner',
      message: 'The student shows understanding of the concept and will benefit from slowing down and checking work more carefully.',
    }
  }

  if (profile.patternType === 'variable-progress') {
    return {
      title: 'Progressing with Some Variation',
      message: 'The student is making progress, though performance varies across stages and may benefit from more consistent review.',
    }
  }

  return {
    title: 'Developing Learner',
    message: 'The student is building foundational understanding and benefits from continued guided practice.',
  }
}

const getPerformanceInterpretation = (profile) => {
  if (profile.achievementBand === 'high' && profile.growthBand === 'strong') {
    return {
      title: 'Strong Growth and Mastery',
      message: 'The student made clear progress and reached a strong level of mastery during this learning cycle.',
    }
  }

  if (profile.achievementBand === 'high') {
    return {
      title: 'Strong Current Performance',
      message: 'The student is already performing at a strong level and is maintaining that understanding well.',
    }
  }

  if (profile.growthBand === 'strong') {
    return {
      title: 'Strong Improvement Curve',
      message: 'The student is learning effectively from review and showing meaningful improvement over time.',
    }
  }

  if (profile.growthBand === 'moderate' || profile.achievementBand === 'medium') {
    return {
      title: 'Healthy Learning Progress',
      message: 'The student is steadily improving and reinforcing understanding across learning stages.',
    }
  }

  return {
    title: 'Building Progress',
    message: 'The student is still developing confidence and may benefit from more guided reinforcement.',
  }
}

const getRecommendation = (profile) => {
  const themeMap = {
    fractions: {
      title: 'Practice Fractions in Daily Life',
      message: 'Using sharing activities with snacks, fruit, or paper folding will help strengthen understanding of fractions.',
    },
    decimals: {
      title: 'Connect Decimals to Real Situations',
      message: 'Practice with money, measurement, and simple number comparisons to make decimal concepts more concrete.',
    },
    'equal-division': {
      title: 'Reinforce Equal Sharing',
      message: 'Simple equal-sharing activities with objects or drawings will help build confidence in dividing into equal groups or pieces.',
    },
    'place-value': {
      title: 'Build Number Sense with Digits',
      message: 'Working with digit cards or making numbers in different ways can strengthen place value understanding.',
    },
    'general-review': {
      title: 'Consistent Practice Needed',
      message: 'Regular review and short practice sessions will help improve both accuracy and confidence.',
    },
  }

  if (profile.achievementBand === 'high' && profile.supportLevel === 'low') {
    return {
      title: 'Maintain Momentum',
      message: 'The student is doing very well. Continued exposure to slightly more challenging problems is recommended.',
    }
  }

  if (profile.supportLevel === 'high' && profile.growthBand === 'low') {
    return {
      title: 'Strengthen Core Understanding',
      message: 'A little more guided review on the current topic will help build stronger accuracy and confidence.',
    }
  }

  return themeMap[profile.recommendationTheme] || themeMap['general-review']
}

const getAiSummary = ({ student, profile }) => {
  const name = student.NAME

  if (profile.achievementBand === 'high' && profile.growthBand === 'strong') {
    return `${name} is showing strong progress and has reached a high level of understanding in ${profile.currentFocus}. Continued practice will help maintain this momentum.`
  }

  if (profile.patternType === 'review-driven') {
    return `${name} may need some time when first meeting new problems, but review and repeated practice are helping build stronger understanding in ${profile.currentFocus}.`
  }

  if (profile.patternType === 'fast-accurate') {
    return `${name} shows strong initial understanding and is working confidently through ${profile.currentFocus}. Continued challenge will support ongoing growth.`
  }

  if (profile.supportLevel === 'high') {
    return `${name} is still building confidence in ${profile.currentFocus}. Additional guided review and short, consistent practice will support stronger understanding.`
  }

  return `${name} is making steady progress in ${profile.currentFocus}. Continued review and practice will help strengthen both understanding and confidence.`
}

const getOverallStatus = (profile) => {
  if (profile.achievementBand === 'high' && profile.growthBand === 'strong') {
    return { title: 'Excellent', message: 'Outstanding progress!' }
  }
  if (profile.achievementBand === 'high' || profile.growthBand === 'strong') {
    return { title: 'Good', message: 'Keep up the good work.' }
  }
  if (profile.achievementBand === 'medium' || profile.growthBand === 'moderate') {
    return { title: 'Average', message: 'There is room for improvement.' }
  }
  return { title: 'Needs Attention', message: "Let's focus on learning." }
}

  const buildBarChartHtml = (uiStageStats) => {
    const chartHeight = 280
    const chartWidth = 720
    const left = 56
    const right = 24
    const top = 22
    const bottom = 54
    const innerWidth = chartWidth - left - right
    const innerHeight = chartHeight - top - bottom
    const maxValue = 100
    const slot = innerWidth / uiStageStats.length
    const barWidth = 54

    const yFor = (value) => top + innerHeight - (Number(value) / maxValue) * innerHeight

    const gridValues = [0, 25, 50, 75, 100]
    const grid = gridValues
      .map((value) => {
        const y = yFor(value)
        return `
          <line x1="${left}" y1="${y}" x2="${chartWidth - right}" y2="${y}" stroke="#E4E7EC" stroke-width="1" stroke-dasharray="3 6" />
          <text x="${left - 12}" y="${y + 4}" text-anchor="end" font-size="13" font-weight="600" fill="#667085">${value}%</text>
        `
      })
      .join('')

    const points = uiStageStats
      .map((item, index) => {
        const x = left + slot * index + slot / 2
        const y = yFor(item.percent)
        return `${x},${y}`
      })
      .join(' ')

    return `
    <div style="background:linear-gradient(180deg,#FFFFFF 0%,#FCFDFF 100%);border-radius:18px;padding:18px 18px 12px 18px;border:1px solid #E7ECF5;box-shadow:0 8px 18px rgba(16,24,40,0.05);position:relative;overflow:hidden;">

      <div style="position:absolute;right:12px;top:10px;opacity:0.08;pointer-events:none;">
        <svg width="160" height="90" viewBox="0 0 160 90" fill="none">
          <defs>
            <linearGradient id="chartDecorLine" x1="18" y1="72" x2="148" y2="16">
              <stop offset="0%" stop-color="#23ADC6"/>
              <stop offset="55%" stop-color="#455BA8"/>
              <stop offset="100%" stop-color="#8EC31F"/>
            </linearGradient>
          </defs>
          <path d="M18 72C34 68 48 64 64 58C78 53 92 46 108 38C122 31 136 24 148 16" stroke="url(#chartDecorLine)" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </div>

      <svg width="100%" viewBox="0 0 ${chartWidth} ${chartHeight}" style="display:block;position:relative;z-index:1;">
        <defs>
          <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#6F87C8" />
            <stop offset="34%" stop-color="#4F69AE" />
            <stop offset="68%" stop-color="#2F4D8E" />
            <stop offset="100%" stop-color="#213766" />
          </linearGradient>
          <linearGradient id="barGloss" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="rgba(255,255,255,0.42)" />
            <stop offset="42%" stop-color="rgba(255,255,255,0.10)" />
            <stop offset="100%" stop-color="rgba(255,255,255,0)" />
          </linearGradient>
        </defs>

        ${grid}

        <line x1="${left}" y1="${top + innerHeight}" x2="${chartWidth - right}" y2="${top + innerHeight}" stroke="#D0D5DD" stroke-width="1.5" />

        ${uiStageStats
          .map((item, index) => {
            const x = left + slot * index + (slot - barWidth) / 2
            const y = yFor(item.percent)
            const height = top + innerHeight - y
            const radius = Math.min(18, barWidth / 2, height)
            const barPath = [
              `M ${x} ${top + innerHeight}`,
              `L ${x} ${y + radius}`,
              `Q ${x} ${y} ${x + radius} ${y}`,
              `L ${x + barWidth - radius} ${y}`,
              `Q ${x + barWidth} ${y} ${x + barWidth} ${y + radius}`,
              `L ${x + barWidth} ${top + innerHeight}`,
              'Z',
            ].join(' ')
            return `
              <path d="${barPath}" fill="url(#barGradient)" style="filter: drop-shadow(0px 10px 16px rgba(33,55,102,0.22));" />
              <path d="M ${x + 6} ${y + 4} L ${x + barWidth - 6} ${y + 4}" stroke="#F3E6B6" stroke-width="1.6" stroke-linecap="round" opacity="0.75" />
              <path d="M ${x + 4} ${y + 3} Q ${x + barWidth / 2} ${y - 2} ${x + barWidth - 4} ${y + 3} L ${x + barWidth - 4} ${y + 18} Q ${x + barWidth / 2} ${y + 10} ${x + 4} ${y + 18} Z" fill="url(#barGloss)" opacity="0.42" />
              <text x="${x + barWidth / 2}" y="${y - 10}" text-anchor="middle" font-size="15" font-weight="900" fill="#425AA8">${item.percent}%</text>
              <text x="${x + barWidth / 2}" y="${chartHeight - 14}" text-anchor="middle" font-size="15" font-weight="800" fill="#475467">${item.stage}</text>
            `
          })
          .join('')}

        <polyline fill="none" stroke="#3D5A98" stroke-width="3.2" points="${points}" />

        ${uiStageStats
          .map((item, index) => {
            const x = left + slot * index + slot / 2
            const y = yFor(item.percent)
            return `<circle cx="${x}" cy="${y}" r="6" fill="#FFFFFF" stroke="#3D5A98" stroke-width="2.2" />`
          })
          .join('')}

      </svg>

      <div style="margin-top:12px;padding:12px 14px;border-radius:14px;background:linear-gradient(180deg,#F8FAFF 0%,#EEF2FF 100%);font-size:14px;color:#475467;display:flex;align-items:center;gap:10px;line-height:1.5;border:1px solid #E3EAF7;">
        <span style="width:26px;height:26px;border-radius:50%;background:#FFFFFF;display:flex;align-items:center;justify-content:center;"><img src="/assets/icons/hint.png" alt="hint" style="width:16px;height:16px;object-fit:contain;" /></span>
        <span>The student's accuracy improved steadily through repeated practice and review.</span>
      </div>

    </div>
  `
  }

  const buildReportHtml = ({
    student,
    uiStageStats,
    improvement,
    learningType,
    performance,
    recommendation,
    overallStatus,
    levelMeta,
    aiSummary,
  }) => {
    const levelInfo = levelMeta?.level || student.LEVEL || 'Unknown Level'
    const levelDetail = levelMeta?.progressLabel || ''
    const levelCode = levelMeta?.levelCode || levelMeta?.levelId || ''
    const levelNumber = String(levelInfo).replace(/level\s*/i, '').trim()
    const firstAccuracy = Number(uiStageStats?.[0]?.percent || 0)
    const latestAccuracy = Number(uiStageStats?.[uiStageStats.length - 1]?.percent || 0)
    const accuracyGain = Number((latestAccuracy - firstAccuracy).toFixed(1))
    const totalProblems = Number(uiStageStats?.[0]?.total || 0)

    const headerDecorSvg = `
      <svg width="260" height="140" viewBox="0 0 260 140" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;opacity:0.22;">
        <defs>
          <linearGradient id="reportDecorLine" x1="24" y1="108" x2="226" y2="22" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stop-color="#23ADC6"/>
            <stop offset="55%" stop-color="#455BA8"/>
            <stop offset="100%" stop-color="#8EC31F"/>
          </linearGradient>
          <linearGradient id="reportDecorBar1" x1="0" y1="86" x2="0" y2="118" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stop-color="#23ADC6" stop-opacity="0.40"/>
            <stop offset="100%" stop-color="#23ADC6" stop-opacity="0.12"/>
          </linearGradient>
          <linearGradient id="reportDecorBar2" x1="0" y1="74" x2="0" y2="118" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stop-color="#455BA8" stop-opacity="0.38"/>
            <stop offset="100%" stop-color="#455BA8" stop-opacity="0.12"/>
          </linearGradient>
          <linearGradient id="reportDecorBar3" x1="0" y1="58" x2="0" y2="118" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stop-color="#8EC31F" stop-opacity="0.34"/>
            <stop offset="100%" stop-color="#8EC31F" stop-opacity="0.12"/>
          </linearGradient>
          <filter id="reportDecorGlow" x="0" y="0" width="260" height="140" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feGaussianBlur stdDeviation="2.2" result="blur"/>
            <feBlend in="SourceGraphic" in2="blur" mode="normal"/>
          </filter>
        </defs>

        <g filter="url(#reportDecorGlow)">
          <rect x="128" y="86" width="22" height="32" rx="6" fill="url(#reportDecorBar1)"/>
          <rect x="164" y="74" width="22" height="44" rx="6" fill="url(#reportDecorBar2)"/>
          <rect x="200" y="58" width="22" height="60" rx="6" fill="url(#reportDecorBar3)"/>
          <rect x="236" y="32" width="22" height="86" rx="6" fill="url(#reportDecorBar2)" opacity="0.85"/>

          <path d="M24 108C48 102 74 97 100 90C124 84 142 78 164 70C184 63 202 51 222 37C232 30 240 24 248 18" stroke="url(#reportDecorLine)" stroke-width="3.5" stroke-linecap="round"/>

          <circle cx="164" cy="70" r="4.5" fill="#23ADC6"/>
          <circle cx="200" cy="52" r="4.5" fill="#455BA8"/>
          <circle cx="248" cy="18" r="5" fill="#8EC31F"/>
        </g>
      </svg>
    `

    const learningPathHtml = (() => {
      const parts = levelDetail
        ? levelDetail.split(' > ').map((item) => item.trim()).filter(Boolean)
        : []

      const labels = ['Main Chapter', 'Sub Chapter', 'Unit', 'Detail Unit']
      const accentPairs = [
        { line: '#F59E0B', tint: 'rgba(245,158,11,0.10)', icon: '📘' },
        { line: '#10B981', tint: 'rgba(16,185,129,0.10)', icon: '🧩' },
        { line: '#6366F1', tint: 'rgba(99,102,241,0.10)', icon: '<img src="/assets/icons/chart.png" alt="chart" style="width:24px;height:24px;object-fit:contain;" />' },
        { line: '#425AA8', tint: 'rgba(66,90,168,0.10)', icon: '<img src="/assets/icons/pencil.png" alt="pencil" style="width:24px;height:24px;object-fit:contain;" />' },
      ]

      if (parts.length === 0) {
        return '<div style="font-size:14px;color:#667085;margin-top:10px;">No chapter information available.</div>'
      }

      return `
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;margin-top:18px;align-items:stretch;">
          ${parts
            .map((step, index) => {
              const isCurrent = index === parts.length - 1
              const accent = accentPairs[index % accentPairs.length]
              return `
                <div style="
                  position:relative;
                  padding:18px 20px;
                  border-radius:18px;
                  background:${isCurrent ? 'linear-gradient(180deg,#F7F9FF 0%,#EEF2FF 100%)' : 'linear-gradient(180deg,#FFFFFF 0%,#FBFCFF 100%)'};
                  border:1.4px solid ${isCurrent ? '#6C82D9' : '#E5EAF3'};
                  box-shadow:${isCurrent ? '0 12px 26px rgba(66,90,168,0.10), 0 4px 10px rgba(16,24,40,0.04)' : '0 10px 22px rgba(16,24,40,0.06), 0 4px 10px rgba(16,24,40,0.03)'};
                  min-height:118px;
                  display:flex;
                  flex-direction:column;
                  justify-content:center;
                  overflow:hidden;
                ">
                  <div style="position:absolute;top:0;left:0;width:4px;height:100%;background:linear-gradient(180deg, ${isCurrent ? '#425AA8' : accent.line} 0%, ${isCurrent ? '#6C82D9' : accent.line} 100%);"></div>
                  <div style="position:absolute;right:-12px;top:-10px;width:92px;height:92px;border-radius:50%;background:${isCurrent ? 'radial-gradient(circle, rgba(66,90,168,0.14) 0%, rgba(66,90,168,0.05) 42%, transparent 72%)' : 'radial-gradient(circle, rgba(66,90,168,0.06) 0%, rgba(66,90,168,0.02) 40%, transparent 72%)'};"></div>
                  <div style="position:absolute;right:18px;top:18px;width:56px;height:56px;border-radius:50%;background:${isCurrent ? 'rgba(66,90,168,0.10)' : accent.tint};display:flex;align-items:center;justify-content:center;font-size:24px;">${accent.icon}</div>

                  <div style="position:relative;z-index:1;max-width:${isCurrent ? '78%' : '82%'};">
                    <div style="font-size:13px;color:#667085;margin-bottom:6px;letter-spacing:0.01em;">
                      ${labels[index] || 'Step'}
                    </div>
                    <div style="font-size:${isCurrent ? '17px' : '16px'};font-weight:800;color:#101828;line-height:1.45;letter-spacing:-0.01em;">
                      ${step}
                    </div>
                    ${isCurrent ? `
                      <div style="margin-top:14px;display:inline-flex;align-items:center;gap:8px;padding:7px 12px;border-radius:999px;background:linear-gradient(180deg,#EEF2FF 0%,#E4EAFF 100%);font-size:12px;font-weight:800;color:#425AA8;box-shadow:inset 0 1px 0 rgba(255,255,255,0.55);">
                        <span style="width:8px;height:8px;border-radius:999px;background:#425AA8;display:inline-block;"></span>
                        Currently Learning
                      </div>
                    ` : ''}
                  </div>
                </div>
              `
            })
            .join('')}
        </div>
      `
    })()

    // --- NEW TEMPLATE STARTS HERE ---
    return `
<html>
  <head>
    <meta charset="utf-8"/>
  </head>

  <body style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;background:#F5F7FB;padding:40px;">

    <div style="max-width:860px;margin:0 auto;background:#ffffff;border-radius:18px;padding:40px;">

      <div style="position:relative;margin-bottom:28px;padding:28px 28px 26px 28px;border-radius:22px;background:linear-gradient(180deg,#FFFFFF 0%,#F8FAFF 100%);border:1px solid #E9EEF7;box-shadow:0 12px 32px rgba(16,24,40,0.08), 0 4px 12px rgba(16,24,40,0.04);overflow:hidden;">

        <div style="position:absolute;left:0;top:0;width:100%;height:4px;background:linear-gradient(90deg,#23ADC6 0%,#455BA8 56%,#8EC31F 100%);"></div>
        <div style="position:absolute;left:-40px;top:-44px;width:220px;height:220px;border-radius:50%;background:radial-gradient(circle, rgba(69,91,168,0.08) 0%, rgba(69,91,168,0.03) 38%, transparent 72%);pointer-events:none;"></div>
        <div style="position:absolute;right:18px;top:12px;opacity:0.20;pointer-events:none;">
          ${headerDecorSvg}
        </div>

        <div style="position:relative;z-index:1;display:flex;justify-content:space-between;align-items:flex-start;gap:20px;">
          <div style="display:flex;align-items:center;gap:12px;">
            <div style="width:38px;height:38px;border-radius:12px;background:linear-gradient(180deg,#FFFFFF 0%,#F3F7FF 100%);border:1px solid #E3EAF7;box-shadow:0 6px 16px rgba(16,24,40,0.06);display:flex;align-items:center;justify-content:center;flex:none;">
              <svg width="28" height="28" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;">
                <path d="M31 42C31 35.5 31 30 31 24" stroke="#455BA8" stroke-width="4.2" stroke-linecap="round"/>
                <path d="M31 30C28 26 24 23 20 21" stroke="#455BA8" stroke-width="4" stroke-linecap="round"/>
                <path d="M31 31C35 27 39 24 44 22" stroke="#455BA8" stroke-width="4" stroke-linecap="round"/>
                <path d="M12 49C17 44 24 42 31 44C38 42 46 43 52 49" stroke="#455BA8" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M31 43C28.5 45.5 27 48 27 52H35C35 48 33.5 45.5 31 43Z" fill="#455BA8"/>
                <ellipse cx="20" cy="18" rx="5" ry="2.8" transform="rotate(-30 20 18)" fill="#8EC31F"/>
                <ellipse cx="27" cy="14" rx="5" ry="2.8" transform="rotate(-60 27 14)" fill="#8EC31F"/>
                <ellipse cx="35" cy="13" rx="5" ry="2.8" transform="rotate(60 35 13)" fill="#8EC31F"/>
                <ellipse cx="43" cy="18" rx="5" ry="2.8" transform="rotate(30 43 18)" fill="#8EC31F"/>
                <ellipse cx="48" cy="26" rx="5" ry="2.8" transform="rotate(0 48 26)" fill="#8EC31F"/>
                <ellipse cx="14" cy="27" rx="5" ry="2.8" transform="rotate(-20 14 27)" fill="#8EC31F"/>
                <circle cx="24" cy="26" r="2.1" fill="#23ADC6"/>
                <circle cx="39" cy="30" r="2.2" fill="#8EC31F"/>
                <circle cx="34" cy="22" r="2.2" fill="#8A66B7"/>
                <path d="M29 25L31 21L33 25L37 25L34 27.5L35 31L31 28.8L27 31L28 27.5L25 25H29Z" fill="#F2B632"/>
              </svg>
            </div>
            <div style="font-size:15px;font-weight:900;color:#1F2A44;letter-spacing:-0.02em;">Solution M</div>
          </div>

          <div style="display:flex;align-items:center;gap:8px;padding:8px 12px;border-radius:999px;background:linear-gradient(180deg,#FFFFFF 0%,#F4F7FF 100%);border:1px solid #E3EAF7;box-shadow:0 4px 10px rgba(16,24,40,0.05);font-size:14px;font-weight:700;color:#344054;position:relative;z-index:2;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;font-size:13px;line-height:1;">📅</span>
            <span>${new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' })}</span>
          </div>
        </div>

        <div style="position:relative;z-index:1;margin-top:24px;max-width:62%;">
          <div style="font-size:34px;font-weight:900;color:#13203B;letter-spacing:-0.03em;line-height:1.08;">
            Monthly Learning Report
          </div>

          <div style="font-size:14px;color:#667085;margin-top:8px;line-height:1.5;">
            Student Performance Summary
          </div>

          <div style="margin-top:18px;display:inline-flex;align-items:stretch;min-width:220px;border-radius:18px;overflow:hidden;background:linear-gradient(180deg,#FFFFFF 0%,#F8FAFF 100%);border:1px solid #E3EAF7;box-shadow:0 8px 18px rgba(16,24,40,0.06);">
            <div style="width:56px;background:linear-gradient(145deg,#3D5A98 0%,#27437C 52%,#213766 100%);position:relative;display:flex;align-items:center;justify-content:center;overflow:hidden;">
              <div style="position:absolute;inset:0;background:linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 26%, transparent 26%, transparent 100%);"></div>
              <div style="position:absolute;right:-10px;bottom:-8px;width:54px;height:54px;background:linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,255,255,0.01));clip-path:polygon(0 100%, 100% 0, 100% 100%);"></div>
              <div style="position:relative;z-index:1;width:28px;height:28px;border-radius:999px;background:rgba(255,255,255,0.12);border:1px solid rgba(255,255,255,0.16);display:flex;align-items:center;justify-content:center;box-shadow:inset 0 1px 0 rgba(255,255,255,0.18);">
                <div style="width:8px;height:8px;border-radius:999px;background:#F3E6B6;"></div>
              </div>
            </div>

            <div style="padding:12px 16px 11px 14px;display:flex;flex-direction:column;justify-content:center;min-width:0;background:linear-gradient(180deg,#F8FAFF 0%,#EEF2FF 100%);position:relative;">
              <div style="position:absolute;right:0;top:0;width:72px;height:100%;opacity:0.22;background:linear-gradient(135deg, transparent 0%, transparent 38%, rgba(158,184,255,0.16) 38%, rgba(158,184,255,0.04) 100%);"></div>
              <div style="position:relative;z-index:1;font-size:12px;color:#667085;line-height:1;margin-bottom:7px;font-weight:700;letter-spacing:0.02em;">Student</div>
              <div style="position:relative;z-index:1;display:flex;align-items:center;gap:10px;min-width:0;">
                <div style="width:8px;height:8px;border-radius:999px;background:#425AA8;flex:none;"></div>
                <div style="font-size:22px;font-weight:900;color:#13203B;line-height:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:220px;">${student.NAME}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="position:relative;padding:22px 22px 20px 22px;background:linear-gradient(180deg,#FFFFFF 0%,#FBFCFF 100%);border-radius:22px;margin-bottom:32px;border:1px solid #E7ECF5;box-shadow:0 10px 20px rgba(16,24,40,0.08), 0 4px 10px rgba(16,24,40,0.04);overflow:hidden;">
        <div style="position:absolute;right:14px;top:10px;opacity:0.14;pointer-events:none;">
          <svg width="220" height="120" viewBox="0 0 220 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="summaryDecorLine" x1="20" y1="92" x2="188" y2="22" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#23ADC6"/>
                <stop offset="55%" stop-color="#455BA8"/>
                <stop offset="100%" stop-color="#8EC31F"/>
              </linearGradient>
              <linearGradient id="summaryDecorBar1" x1="0" y1="66" x2="0" y2="100" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#23ADC6" stop-opacity="0.42"/>
                <stop offset="100%" stop-color="#23ADC6" stop-opacity="0.12"/>
              </linearGradient>
              <linearGradient id="summaryDecorBar2" x1="0" y1="54" x2="0" y2="100" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#455BA8" stop-opacity="0.40"/>
                <stop offset="100%" stop-color="#455BA8" stop-opacity="0.12"/>
              </linearGradient>
              <linearGradient id="summaryDecorBar3" x1="0" y1="34" x2="0" y2="100" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#8EC31F" stop-opacity="0.34"/>
                <stop offset="100%" stop-color="#8EC31F" stop-opacity="0.12"/>
              </linearGradient>
            </defs>
            <rect x="138" y="66" width="20" height="34" rx="6" fill="url(#summaryDecorBar1)"/>
            <rect x="170" y="54" width="20" height="46" rx="6" fill="url(#summaryDecorBar2)"/>
            <rect x="202" y="34" width="20" height="66" rx="6" fill="url(#summaryDecorBar3)"/>
            <path d="M18 90C40 86 60 82 84 74C102 68 122 58 144 50C162 43 178 31 194 18" stroke="url(#summaryDecorLine)" stroke-width="3.2" stroke-linecap="round"/>
            <circle cx="144" cy="50" r="4.5" fill="#23ADC6"/>
            <circle cx="194" cy="18" r="5" fill="#8EC31F"/>
          </svg>
        </div>

        <div style="display:grid;grid-template-columns:128px 1fr;gap:22px;align-items:stretch;position:relative;z-index:1;">
          <div style="display:flex;align-items:center;justify-content:center;">
            <div style="width:100%;height:240px;border-radius:22px;background:linear-gradient(145deg,#3D5A98 0%,#27437C 52%,#213766 100%);border:1px solid #2B457A;box-shadow:inset 0 1px 0 rgba(255,255,255,0.08), 0 10px 24px rgba(39,67,124,0.14);overflow:hidden;position:relative;display:flex;flex-direction:column;justify-content:space-between;">
              <div style="position:absolute;inset:0;background:linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 24%, transparent 24%, transparent 100%);"></div>
              <div style="position:absolute;right:-18px;bottom:-10px;width:110px;height:110px;background:linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.01));clip-path:polygon(0 100%, 100% 0, 100% 100%);"></div>

              <div style="flex:1;display:flex;align-items:center;justify-content:center;position:relative;z-index:1;padding-top:10px;">
                <div style="width:78px;height:102px;clip-path:polygon(50% 0%, 88% 18%, 88% 76%, 50% 100%, 12% 76%, 12% 18%);border:1.4px solid rgba(244,221,157,0.92);box-shadow:0 0 0 2px rgba(244,221,157,0.10);display:flex;flex-direction:column;align-items:center;justify-content:center;background:linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.02) 100%);">
                  <div style="font-size:10px;color:#F3E6B6;letter-spacing:0.12em;margin-bottom:6px;font-weight:800;">LEVEL</div>
                  <div style="font-size:40px;font-weight:900;color:#FFFFFF;line-height:0.9;letter-spacing:-0.04em;text-shadow:0 4px 14px rgba(0,0,0,0.18);">${levelNumber}</div>
                </div>
              </div>

              <div style="position:relative;z-index:1;padding:14px 14px 14px 14px;background:linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.05) 100%);border-top:1px solid rgba(255,255,255,0.08);">
                <div style="width:34px;height:2.5px;border-radius:999px;background:linear-gradient(90deg,#F3E6B6 0%, rgba(243,230,182,0.28) 100%);margin-bottom:9px;"></div>
                <div style="font-size:11px;color:rgba(255,255,255,0.92);line-height:1.45;letter-spacing:-0.01em;font-weight:600;">Current curriculum stage</div>
              </div>
            </div>
          </div>

          <div style="display:flex;flex-direction:column;justify-content:space-between;min-width:0;">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:14px;">
              <div>
                <div style="font-size:11px;color:#667085;letter-spacing:0.08em;margin-bottom:6px;">CURRENT ACCURACY</div>
                <div style="font-size:48px;font-weight:900;color:#13203B;letter-spacing:-0.05em;line-height:0.95;">${latestAccuracy}%</div>
                <div style="margin-top:6px;font-size:13px;color:#667085;line-height:1.45;">Based on ${totalProblems} total problems</div>
              </div>

              <div style="display:inline-flex;align-items:center;justify-content:center;padding:9px 14px;border-radius:999px;background:linear-gradient(180deg,#EEF2FF 0%,#E6ECFF 100%);border:1px solid #D9E2FF;font-size:11px;font-weight:800;color:#425AA8;white-space:nowrap;box-shadow:0 4px 10px rgba(66,90,168,0.08);">
                ${performance.title}
              </div>
            </div>

            <div style="margin-top:16px;border-radius:18px;background:linear-gradient(180deg,#FAFBFF 0%,#F6F8FD 100%);border:1px solid #E3E9F4;display:grid;grid-template-columns:1fr 50px 1fr 50px 1fr 50px 1fr;align-items:center;overflow:hidden;box-shadow:inset 0 1px 0 rgba(255,255,255,0.65);min-height:116px;">
              <div style="padding:16px 16px;display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:0;">
                <div style="width:42px;height:42px;border-radius:999px;background:#EEF2FF;border:1px solid #D9E2FF;display:flex;align-items:center;justify-content:center;margin-bottom:9px;">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6" y="4" width="12" height="16" rx="2" stroke="#425AA8" stroke-width="1.7"/>
                    <path d="M9 8H15" stroke="#425AA8" stroke-width="1.7" stroke-linecap="round"/>
                    <path d="M9 12H13" stroke="#425AA8" stroke-width="1.7" stroke-linecap="round"/>
                  </svg>
                </div>
                <div style="font-size:10px;color:#667085;letter-spacing:0.08em;margin-bottom:6px;">FIRST ATTEMPT</div>
                <div style="font-size:24px;font-weight:900;color:#98A2B3;letter-spacing:-0.03em;line-height:1;">${firstAccuracy}%</div>
              </div>

              <div style="display:flex;align-items:center;justify-content:center;">
                <div style="width:26px;height:26px;border-radius:999px;background:#F4F7FE;border:1px solid #D9E2F2;display:flex;align-items:center;justify-content:center;font-size:14px;color:#98A2B3;font-weight:700;opacity:0.55;box-shadow:0 3px 8px rgba(16,24,40,0.05);">→</div>
              </div>

              <div style="display:flex;align-items:center;justify-content:center;min-width:0;">
                <div style="padding:12px 18px;border-radius:14px;background:linear-gradient(180deg,#F0FDF4 0%,#ECFDF3 100%);border:1px solid #D1FAE5;display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:146px;">
                  <div style="width:42px;height:42px;border-radius:999px;background:linear-gradient(180deg,#F4FBF7 0%,#ECF8F1 100%);border:1px solid #D7ECDD;display:flex;align-items:center;justify-content:center;margin-bottom:9px;box-shadow:0 8px 18px rgba(30,142,90,0.08);">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 16L10 10L14 14L20 8" stroke="#1E8E5A" stroke-width="2.0" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M15 8H20V13" stroke="#1E8E5A" stroke-width="2.0" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div style="font-size:11px;font-weight:800;color:#667085;letter-spacing:0.06em;margin-bottom:6px;">ACCURACY GAIN</div>
                  <div style="font-size:26px;font-weight:900;color:${accuracyGain >= 0 ? '#16A34A' : '#DC2626'};letter-spacing:-0.03em;line-height:1;">
                    ${accuracyGain >= 0 ? '+' : ''}${accuracyGain}%
                  </div>
                </div>
              </div>

              <div style="display:flex;align-items:center;justify-content:center;">
                <div style="width:26px;height:26px;border-radius:999px;background:#F4F7FE;border:1px solid #D9E2F2;display:flex;align-items:center;justify-content:center;font-size:14px;color:#98A2B3;font-weight:700;opacity:0.55;box-shadow:0 3px 8px rgba(16,24,40,0.05);">•</div>
              </div>

              <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:0;padding:16px 12px;">
                <div style="width:42px;height:42px;border-radius:999px;background:#FFF7E8;border:1px solid #F3E6B6;display:flex;align-items:center;justify-content:center;margin-bottom:9px;">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7H19" stroke="#B7791F" stroke-width="1.8" stroke-linecap="round"/>
                    <path d="M5 12H19" stroke="#B7791F" stroke-width="1.8" stroke-linecap="round"/>
                    <path d="M5 17H14" stroke="#B7791F" stroke-width="1.8" stroke-linecap="round"/>
                  </svg>
                </div>
                <div style="font-size:10px;color:#667085;letter-spacing:0.08em;margin-bottom:6px;">TOTAL PROBLEMS</div>
                <div style="font-size:24px;font-weight:900;color:#B7791F;letter-spacing:-0.03em;line-height:1;">${totalProblems}</div>
              </div>

              <div style="display:flex;align-items:center;justify-content:center;">
                <div style="width:26px;height:26px;border-radius:999px;background:#F4F7FE;border:1px solid #D9E2F2;display:flex;align-items:center;justify-content:center;font-size:14px;color:#98A2B3;font-weight:700;opacity:0.55;box-shadow:0 3px 8px rgba(16,24,40,0.05);">→</div>
              </div>

              <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:0;">
                <div style="width:42px;height:42px;border-radius:999px;background:#EEF2FF;border:1px solid #D9E2FF;display:flex;align-items:center;justify-content:center;margin-bottom:9px;">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="7" stroke="#425AA8" stroke-width="1.7"/>
                    <circle cx="12" cy="12" r="2" fill="#425AA8"/>
                    <path d="M12 12L16 9" stroke="#425AA8" stroke-width="1.7" stroke-linecap="round"/>
                  </svg>
                </div>
                <div style="font-size:10px;color:#667085;letter-spacing:0.08em;margin-bottom:6px;">LATEST ATTEMPT</div>
                <div style="font-size:24px;font-weight:900;color:#425AA8;letter-spacing:-0.03em;line-height:1;">${latestAccuracy}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-bottom:32px;padding:22px 22px 20px 22px;border-radius:22px;background:linear-gradient(180deg,#FFFFFF 0%,#FBFCFF 100%);border:1px solid #E7ECF5;box-shadow:0 10px 20px rgba(16,24,40,0.08), 0 4px 10px rgba(16,24,40,0.04);position:relative;overflow:hidden;">
        <div style="position:absolute;right:16px;top:10px;opacity:0.10;pointer-events:none;">
          ${headerDecorSvg}
        </div>
        <div style="position:relative;z-index:1;display:flex;align-items:flex-end;justify-content:space-between;gap:16px;">
          <div>
            <div style="display:flex;align-items:center;gap:10px;margin-bottom:6px;">
              <div style="width:4px;height:18px;background:#425AA8;border-radius:2px;"></div>
              <div style="font-size:20px;font-weight:900;color:#101828;letter-spacing:-0.02em;">
                Learning Path
              </div>
            </div>
            <div style="font-size:13px;color:#667085;line-height:1.45;">
              Current topic in the curriculum
            </div>
            ${levelCode ? `
              <div style="margin-top:10px;display:inline-flex;align-items:center;gap:8px;padding:7px 12px;border-radius:999px;background:linear-gradient(180deg,#FFFFFF 0%,#F4F7FF 100%);border:1px solid #DDE6F7;font-size:12px;font-weight:900;color:#425AA8;letter-spacing:0.02em;box-shadow:0 4px 10px rgba(16,24,40,0.04);">
                <span style="font-size:11px;color:#667085;font-weight:800;letter-spacing:0.08em;">CURRENT LEVEL</span>
                <span>${levelCode}</span>
              </div>
            ` : ''}
          </div>
        </div>
        <div style="position:relative;z-index:1;">
          ${learningPathHtml}
        </div>
      </div>

      <div style="margin-bottom:32px;">
        <div style="display:flex;gap:16px;">
          
          <!-- LEFT: CHART -->
          <div style="flex:2;background:#ffffff;border:1px solid #E4E7EC;border-radius:16px;padding:20px;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
              <div style="font-size:16px;font-weight:800;color:#101828;letter-spacing:-0.01em;">Learning Progress</div>
              <div style="font-size:13px;color:#667085;">Accuracy improvement across learning stages</div>
            </div>
            ${buildBarChartHtml(uiStageStats)}
          </div>

          <!-- RIGHT: IMPROVEMENT -->
          <div style="flex:1;background:#ffffff;border:1px solid #E4E7EC;border-radius:16px;padding:20px;display:flex;flex-direction:column;justify-content:space-between;">
            
            <div>
              <div style="font-size:13px;color:#667085;margin-bottom:6px;letter-spacing:0.02em;">Key Improvement</div>
              <div style="font-size:46px;font-weight:900;color:#425AA8;letter-spacing:-0.03em;line-height:1;">+${improvement.toFixed(1)}%</div>
              <div style="margin-top:8px;font-size:13px;font-weight:700;color:#425AA8;background:#EEF2FF;display:inline-block;padding:5px 12px;border-radius:999px;">
                Strong Improvement
              </div>
              <div style="margin-top:12px;font-size:14px;color:#475467;line-height:1.55;max-width:230px;">
                Great job! Your performance has improved significantly this month.
              </div>
            </div>

            <!-- MINI TREND GRAPH -->
            <div style="margin-top:22px;height:130px;display:flex;align-items:flex-end;">
              <svg width="100%" height="130" viewBox="0 0 240 130">
                <defs>
                  <linearGradient id="miniTrendFill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stop-color="#4F69AE" stop-opacity="0.56"/>
                    <stop offset="52%" stop-color="#2F4D8E" stop-opacity="0.24"/>
                    <stop offset="100%" stop-color="#213766" stop-opacity="0.02"/>
                  </linearGradient>
                  <pattern id="miniTrendDots" width="12" height="12" patternUnits="userSpaceOnUse">
                    <circle cx="6" cy="6" r="1.1" fill="#FFFFFF" opacity="0.14"/>
                  </pattern>
                  <linearGradient id="miniTrendGold" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stop-color="#F3E6B6"/>
                    <stop offset="100%" stop-color="#D9B35B"/>
                  </linearGradient>
                </defs>

                <path d="M10 95 C32 83, 54 77, 74 74 C92 71, 108 69, 126 60 C146 50, 166 43, 188 36 C200 32, 210 29, 220 24 L220 130 L10 130 Z" fill="url(#miniTrendFill)"/>
                <path d="M10 95 C32 83, 54 77, 74 74 C92 71, 108 69, 126 60 C146 50, 166 43, 188 36 C200 32, 210 29, 220 24 L220 130 L10 130 Z" fill="url(#miniTrendDots)" opacity="0.65"/>

                <rect x="176" y="54" width="8" height="62" rx="4" fill="#FFFFFF" opacity="0.08"/>
                <rect x="190" y="42" width="8" height="74" rx="4" fill="#FFFFFF" opacity="0.10"/>
                <rect x="204" y="28" width="8" height="88" rx="4" fill="#FFFFFF" opacity="0.12"/>

                <path d="M10 95 C32 83, 54 77, 74 74 C92 71, 108 69, 126 60 C146 50, 166 43, 188 36 C200 32, 210 29, 220 24" fill="none" stroke="#213766" stroke-width="4.6" stroke-linecap="round"/>
                <path d="M10 94 C32 82, 54 76, 74 73 C92 70, 108 68, 126 59 C146 49, 166 42, 188 35 C200 31, 210 28, 220 23" fill="none" stroke="#3D5A98" stroke-width="3.2" stroke-linecap="round"/>

                <path d="M146 48 C170 38, 196 31, 220 23" fill="none" stroke="url(#miniTrendGold)" stroke-width="1.8" stroke-linecap="round" opacity="0.95"/>

                <circle cx="220" cy="24" r="6.2" fill="#FFFFFF" stroke="#3D5A98" stroke-width="2.6" />
                <circle cx="220" cy="24" r="12.5" fill="#3D5A98" opacity="0.10" />
                <circle cx="220" cy="24" r="18" fill="#D9B35B" opacity="0.12" />
              </svg>
            </div>

          </div>

        </div>
      </div>

      <div style="display:flex;gap:16px;align-items:stretch;">

        <div style="flex:1;position:relative;padding:20px 22px 18px 22px;border-radius:18px;background:linear-gradient(180deg,#F5F7FF 0%,#EEF2FF 100%);border:1px solid #DCE4FF;box-shadow:0 10px 22px rgba(16,24,40,0.08), 0 4px 10px rgba(16,24,40,0.04);overflow:hidden;">
          <div style="position:absolute;right:-10px;top:-12px;width:96px;height:96px;border-radius:50%;background:radial-gradient(circle, rgba(66,90,168,0.14) 0%, rgba(66,90,168,0.05) 42%, transparent 72%);"></div>
          <div style="position:absolute;right:16px;top:16px;width:44px;height:44px;border-radius:50%;background:rgba(66,90,168,0.10);display:flex;align-items:center;justify-content:center;box-shadow:inset 0 1px 0 rgba(255,255,255,0.45);">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M8 3C5 3 3 5 3 8C3 10 4 11 5 12C4 13 3 14 3 16C3 19 5 21 8 21H16C19 21 21 19 21 16C21 14 20 13 19 12C20 11 21 10 21 8C21 5 19 3 16 3H8Z" stroke="#425AA8" stroke-width="1.9"/>
            </svg>
          </div>
          <div style="position:relative;z-index:1;">
            <div style="font-size:12px;color:#5B6ACF;font-weight:800;letter-spacing:0.08em;">LEARNING PROFILE</div>
            <div style="font-weight:900;color:#101828;margin-top:10px;font-size:17px;line-height:1.2;max-width:78%;">${learningType.title}</div>
            <div style="width:44px;height:3px;border-radius:999px;background:linear-gradient(90deg,#425AA8 0%, rgba(66,90,168,0.18) 100%);margin-top:14px;"></div>
            <div style="font-size:14px;color:#475467;margin-top:14px;line-height:1.65;max-width:86%;">${learningType.message}</div>
          </div>
        </div>

        <div style="flex:1;position:relative;padding:20px 22px 18px 22px;border-radius:18px;background:linear-gradient(180deg,#F1FCF6 0%,#E7F8EF 100%);border:1px solid #CDEEDB;box-shadow:0 10px 22px rgba(16,24,40,0.08), 0 4px 10px rgba(16,24,40,0.04);overflow:hidden;">
          <div style="position:absolute;right:-10px;top:-12px;width:96px;height:96px;border-radius:50%;background:radial-gradient(circle, rgba(22,163,74,0.14) 0%, rgba(22,163,74,0.05) 42%, transparent 72%);"></div>
          <div style="position:absolute;right:16px;top:16px;width:44px;height:44px;border-radius:50%;background:rgba(22,163,74,0.10);display:flex;align-items:center;justify-content:center;box-shadow:inset 0 1px 0 rgba(255,255,255,0.45);">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M4 16L10 10L14 14L20 6" stroke="#159947" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 6H20V11" stroke="#159947" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div style="position:relative;z-index:1;">
            <div style="font-size:12px;color:#159947;font-weight:800;letter-spacing:0.08em;">PERFORMANCE</div>
            <div style="font-weight:900;color:#101828;margin-top:10px;font-size:17px;line-height:1.2;max-width:78%;">${performance.title}</div>
            <div style="width:44px;height:3px;border-radius:999px;background:linear-gradient(90deg,#16A34A 0%, rgba(22,163,74,0.18) 100%);margin-top:14px;"></div>
            <div style="font-size:14px;color:#475467;margin-top:14px;line-height:1.65;max-width:86%;">${performance.message}</div>
          </div>
        </div>

        <div style="flex:1;position:relative;padding:20px 22px 18px 22px;border-radius:18px;background:linear-gradient(180deg,#FFF9EC 0%,#FEF0C8 100%);border:1px solid #F8D98A;box-shadow:0 10px 22px rgba(16,24,40,0.08), 0 4px 10px rgba(16,24,40,0.04);overflow:hidden;">
          <div style="position:absolute;right:-10px;top:-12px;width:96px;height:96px;border-radius:50%;background:radial-gradient(circle, rgba(217,119,6,0.14) 0%, rgba(217,119,6,0.05) 42%, transparent 72%);"></div>
          <div style="position:absolute;right:16px;top:16px;width:44px;height:44px;border-radius:50%;background:rgba(217,119,6,0.10);display:flex;align-items:center;justify-content:center;box-shadow:inset 0 1px 0 rgba(255,255,255,0.45);">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="8" stroke="#D97706" stroke-width="1.9"/>
              <circle cx="12" cy="12" r="4" stroke="#D97706" stroke-width="1.9"/>
              <circle cx="12" cy="12" r="1.5" fill="#D97706"/>
            </svg>
          </div>
          <div style="position:relative;z-index:1;">
            <div style="font-size:12px;color:#D97706;font-weight:800;letter-spacing:0.08em;">RECOMMENDATION</div>
            <div style="font-weight:900;color:#101828;margin-top:10px;font-size:17px;line-height:1.2;max-width:78%;">${recommendation.title}</div>
            <div style="width:44px;height:3px;border-radius:999px;background:linear-gradient(90deg,#D97706 0%, rgba(217,119,6,0.18) 100%);margin-top:14px;"></div>
            <div style="font-size:14px;color:#475467;margin-top:14px;line-height:1.65;max-width:86%;">${recommendation.message}</div>
          </div>
        </div>

      </div>

      <div style="margin-top:24px;padding:22px 22px 20px 22px;border-radius:18px;background:linear-gradient(180deg,#F3F6FF 0%,#E9EEFF 100%);border:1px solid #DCE4FF;box-shadow:0 10px 22px rgba(16,24,40,0.08), 0 4px 10px rgba(16,24,40,0.04);position:relative;overflow:hidden;display:flex;justify-content:space-between;align-items:center;gap:20px;position:relative;border-left:6px solid #425AA8;">
        <div style="position:absolute;inset:0;background:linear-gradient(135deg, transparent 0%, transparent 60%, rgba(66,90,168,0.05) 60%, rgba(66,90,168,0.02) 100%);pointer-events:none;"></div>
        <div style="position:absolute;right:16px;top:10px;opacity:0.09;pointer-events:none;">
          ${headerDecorSvg}
        </div>

        <div style="position:relative;z-index:1;display:flex;gap:14px;align-items:flex-start;max-width:72%;">
          <div style="width:48px;height:48px;border-radius:50%;background:linear-gradient(180deg,#EEF2FF 0%,#E4EAFF 100%);border:1px solid #D6DEFF;display:flex;align-items:center;justify-content:center;flex:none;box-shadow:inset 0 1px 0 rgba(255,255,255,0.45);font-size:24px;color:#425AA8;line-height:1;">“</div>

          <div>
            <div style="font-size:12px;font-weight:900;color:#425AA8;letter-spacing:0.12em;margin-bottom:8px;">TEACHER INSIGHT</div>
            <div style="font-size:15px;color:#344054;line-height:1.75;max-width:560px;">
              ${aiSummary}
            </div>
          </div>
        </div>

        <div style="position:relative;z-index:1;text-align:right;min-width:170px;padding-left:16px;border-left:1px solid #E0E6F5;">
          <div style="font-size:15px;font-weight:900;color:#344054;line-height:1.2;">Solution M Team</div>
          <div style="font-size:12px;color:#667085;margin-top:6px;line-height:1.45;">Math Education Specialist</div>
        </div>
      </div>

      <div style="margin-top:28px;text-align:center;font-size:12px;color:#98A2B3;display:flex;align-items:center;justify-content:center;gap:6px;">
        <img src="/assets/icons/lock.png" alt="lock" style="width:14px;height:14px;object-fit:contain;" />
        <span>This report is generated by Solution M. All data is secure and confidential.</span>
      </div>

    </div>
  </body>
</html>
`
}


  const handleGenerateReport = async () => {
    if (!selectedUser) return
    setIsGeneratingReport(true)
    try {
      const [yearStr, monthStr] = reportMonth.split('-')
      const year  = parseInt(yearStr, 10)
      const month = parseInt(monthStr, 10)

      const reportRes = await apiRequest('/report/monthly', 'POST', {
        USER_ID:    selectedUser.USER_ID,
        NUMERIC_ID: selectedUser.ID,
        CENTER_ID:  selectedUser.CENTER_ID,
        year,
        month,
      })

      if (!reportRes?.success) {
        notifications.show({ title: 'No Data', message: '리포트 데이터를 불러올 수 없습니다.', color: 'yellow' })
        return
      }

      // 저장 시각 업데이트
      setReportSavedAt(reportRes.savedAt || null)

      const pages    = buildMonthlyReportPages(reportRes.data)
      const pdf      = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })
      const pdfWidth = pdf.internal.pageSize.getWidth()

      for (let i = 0; i < pages.length; i++) {
        const container = document.createElement('div')
        container.style.position = 'fixed'
        container.style.left     = '-9999px'
        container.style.top      = '0'
        container.style.width    = '870px'
        container.style.background = '#F8FAFC'
        container.innerHTML = pages[i]
        document.body.appendChild(container)

        await new Promise(r => setTimeout(r, 350))

        const canvas = await html2canvas(container, { scale: 2, useCORS: true, backgroundColor: '#F8FAFC' })
        document.body.removeChild(container)

        const imgHeight = (canvas.height * pdfWidth) / canvas.width
        if (i > 0) pdf.addPage()
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, pdfWidth, imgHeight)
      }

      pdf.save(`report_${selectedUser.NAME}_${reportMonth}.pdf`)
      const cacheMsg = reportRes.fromCache ? ' (저장된 리포트)' : ' (새로 생성됨)'
      notifications.show({ title: 'Report Generated', message: `PDF 리포트가 생성됐습니다.${cacheMsg}`, color: 'green' })
    } catch (e) {
      console.error('report generation failed:', e)
      notifications.show({ title: 'Report Failed', message: '리포트 생성 중 오류가 발생했습니다.', color: 'red' })
    } finally {
      setIsGeneratingReport(false)
    }
  }

  const MONTH_PRICE = 20
  const YEAR_PRICE = 199

  // 파생값
  const unpaidCount = pendingTargets.length // 이번에 결제할 좌석
  const totalUsers = totalUser.length // 현재 총원(결제 기준 인원)
  const subUnit = subCycle === 'M' ? MONTH_PRICE : YEAR_PRICE

  const paidStart = Math.max(0, totalUsers - unpaidCount)
  const overallTotalIfAllPaid = useMemo(
    () => calcTotalForCount(paidStart + unpaidCount),
    [paidStart, unpaidCount]
  )
  const subTotal = useMemo(
    () => calcDeltaFromCurrent(paidStart, unpaidCount),
    [paidStart, unpaidCount]
  )
  const base = unpaidCount * 20 // 명목가
  const discountAmt = Number((base - subTotal).toFixed(2))

  const stateData = [
    { value: '', label: 'All' },
    { value: 'Y', label: 'Active' },
    { value: 'N', label: 'Inactive' },
  ]

  const SUB_DATA = [
    { value: 'Y', label: 'Active' },
    { value: 'N', label: 'Inactive' },
  ]

  const roleLabel = (code) =>
    ({
      U: 'User',
      F: 'Offline',
      T: 'Teacher',
      M: 'Manager',
    }[code] ?? code)

  const hasGardianInfo = () => {
    return !!editForm.GUARDIAN_NAME
  }

  const buildUsersList = (details) =>
    details.map((user, index) => ({
      NO: index + 1,
      NAME: user.NAME,
      PHONE: user.PHONE,
      CENTER: user.CENTER_NAME,
      SUB: user.SUB === 'Y' ? 'Active' : 'Inactive',
      ROLE: user.ROLE,
      STATE: user.STATE === 'Y' ? 'Active' : 'Inactive',
      LEVEL: user.LEVEL === 'level 99' ? 'TEST' : user.LEVEL,
      DATE: user.REG_DTM,
    }))

  const resetEditForm = () => setEditForm(defaultUserForm)

  const handleSort = (field) => {
    if (!field) return
    setSortConfig((prev) => ({
      field,
      dir: prev.field === field && prev.dir === 'asc' ? 'desc' : 'asc',
    }))
    setCurrentPage(1)
  }

  const getSortedList = () => {
    if (!sortConfig.field) return usersList
    return [...usersList].sort((a, b) => {
      let aVal = a[sortConfig.field] ?? ''
      let bVal = b[sortConfig.field] ?? ''
      if (sortConfig.field === 'LEVEL') {
        aVal = parseInt(aVal.replace(/\D/g, ''), 10) || 0
        bVal = parseInt(bVal.replace(/\D/g, ''), 10) || 0
        return sortConfig.dir === 'asc' ? aVal - bVal : bVal - aVal
      }
      const cmp = String(aVal).localeCompare(String(bVal))
      return sortConfig.dir === 'asc' ? cmp : -cmp
    })
  }

  const headers = SORTABLE_COLS.map(({ label, field }) =>
    field ? (
      <span
        key={label}
        onClick={() => handleSort(field)}
        style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
      >
        {label}
        <span style={{ fontSize: '10px', color: sortConfig.field === field ? '#344054' : '#d0d5dd' }}>
          {sortConfig.field === field ? (sortConfig.dir === 'asc' ? '▲' : '▼') : '⇅'}
        </span>
      </span>
    ) : label
  )

  const getCurrentPageData = () => {
    const sorted = getSortedList()
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return sorted.slice(startIndex, endIndex)
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const handleItemsPerPageChange = (value) => {
    const numValue = parseInt(value.replace('entries', ''))
    setItemsPerPage(numValue)
    setCurrentPage(1)
  }

  const totalPages = Math.ceil(usersList.length / itemsPerPage)

  const handleInputChange = (field, value) => {
    setEditForm((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  useEffect(() => {
    setCENTER_NAME(user.CENTER_ID)
  }, [user.CENTER_ID])

  useEffect(() => {
    if (CENTER_NAME !== '') {
      fetchUsersList()
    }
  }, [CENTER_NAME])

    useEffect(() => {
      fetchCountries()
      fetchCenters()
      fetchChapters()
    }, [])

  const fetchCountries = async () => {
    try {
      const res = await apiRequest('/getCountry', 'POST')
      if (res.data) {
        setCountries(res.data)
      }
    } catch (err) {
      console.error('국가 데이터 가져오기 실패:', err)
      notifications.show({
        title: 'Error',
        message: '국가 데이터를 불러오는데 실패했습니다.',
        color: 'red',
      })
    }
  }

  const fetchCenters = async () => {
    try {
      const res = await apiRequest('/centers/list', 'POST')
      if (res.data) {
        // value-label 형식으로 변환
        const formatted = res.data.map((center) => ({
          value: String(center.CENTER_ID),
          label: center.NAME,
        }))

        setCENTER_DATA([{ value: '', label: 'All' }, ...formatted])
      }
    } catch (err) {
      console.error('센터 데이터 가져오기 실패:', err)
      notifications.show({
        title: 'Error',
        message: '센터 데이터를 불러오는데 실패했습니다.',
        color: 'red',
      })
    }
  }
    const fetchChapters = async () => {
  try {
    const res = await apiRequest('/chapters/list', 'POST')

    if (res?.data) {
      const map = {}

      res.data.forEach((item) => {
        map[String(item.LEVEL_ID)] = [
          item.MAIN,
          item.SUB,
          item.UNIT,
          item.DETAIL_UNIT,
        ]
          .filter(Boolean)
          .map((text) => String(text).replace(/\s*\([^)]*\)/g, ''))
          .filter(Boolean)
          .join(' > ')
      })

      const orderedLevelIds = res.data
        .map((item) => String(item.LEVEL_ID || '').trim())
        .filter(Boolean)
        .sort((a, b) => Number(a) - Number(b))

      setChapterMap(map)
      setChapterOrder(orderedLevelIds)
    }
  } catch (err) {
    console.error('챕터 데이터 가져오기 실패:', err)
  }
}

  // --- CSV Export helpers ---
  const stageMap = {
    0: 'First Try',
    1: 'Review 1',
    2: 'Review 2',
    3: 'Mastery',
  }

  const convertStats = (data) => {
    const total = Number(data?.TOTAL?.total_problems || 0)
    if (!total) return []

    const wrongData = Array.isArray(data?.WRONG) ? data.WRONG : []
    const defaultAttempts = [0, 1, 2, 3].map((attempt) => ({ attempt, value: 0 }))
    const attempts = wrongData.length > 0 ? wrongData : defaultAttempts

    return attempts.map((item, index) => {
      const wrong = Number(item.value || 0)
      const correct = Math.max(0, total - wrong)
      const percent = total ? Number(((correct / total) * 100).toFixed(1)) : 0

      return {
        attempt: item.attempt ?? index,
        correct,
        wrong,
        total,
        percent,
      }
    })
  }


const fetchDashboardStats = async (student) => {
  const payloadCandidates = [
    { ID: student.ID, USER_ID: student.USER_ID },
    { ID: student.ID },
    { USER_ID: student.USER_ID },
  ]

  for (const payload of payloadCandidates) {
    try {
      const res = await apiRequest('/fetchStudentDashboard', 'POST', payload)
      if (res?.data) {
        return res.data
      }
    } catch (err) {
      // 다음 payload 시도
    }
  }

  throw new Error('fetchStudentDashboard fail')
}

  const handleExportCSV = async () => {
    const today = new Date().toISOString().slice(0, 10)

    const rows = [
      [
        'Date',
        'Center',
        'Student',
        'Start Date',
        'Learning Day',
        'Current Level',
        'Stage',
        'Correct',
        'Wrong',
        'Total',
        'Percent',
      ],
    ]

    setIsExporting(true)

    try {
      const results = await Promise.all(
        detailUsersList.map(async (student) => {
          try {
            const dashboardData = await fetchDashboardStats(student)
            const stats = convertStats(dashboardData)

            return stats.map((s) => ({ student, ...s }))
          } catch (err) {
            console.log('error for student:', student.USER_ID || student.ID, err)
            return null
          }
        })
      )

      results.forEach((item) => {
        if (!item) return

        const uiStages = item.slice(0, 4)

        uiStages.forEach((s, index) => {
          const levelCode = String(s.student.LEVEL_ID || '')
            .trim()
            .split('')
            .filter(Boolean)
            .join('-')

          const startDate = s.student.REG_DTM || ''
          const learningDay = s.student.STEP
            ? `Day ${s.student.STEP}`
            : getLearningDayFromLevelId(s.student.LEVEL_ID)

          rows.push([
            today,
            s.student.CENTER_NAME,
            s.student.NAME,
            startDate,
            learningDay,
            levelCode,
            stageMap[index],
            s.correct,
            s.wrong,
            s.total,
            s.percent,
          ])
        })
      })

      if (rows.length === 1) {
        notifications.show({
          title: 'No Data',
          message: '학생 데이터 없음',
          color: 'yellow',
        })
        return
      }

      const worksheet = XLSX.utils.aoa_to_sheet(rows)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Stats')

      XLSX.writeFile(workbook, `student_stats_${today}.xlsx`)

    } catch (e) {
      console.error('export failed:', e)
    } finally {
      setIsExporting(false)
    }
  }
  const fetchUsersList = async () => {
    try {
      const res = await apiRequest('/users/list', 'POST', {
        CENTER_ID: CENTER_NAME,
        NAME: NAME,
        PHONE: PHONE,
        STATE: STATE,
      })
      if (res.success === 'Y' && res.data) {
        setDetailUsersList(res.data)

        const filteredData = res.data.map((user, index) => ({
          NO: index + 1,
          NAME: user.NAME,
          PHONE: user.PHONE,
          CENTER: user.CENTER_NAME,
          SUB: user.SUB === 'Y' ? 'Active' : 'Inactive',
          ROLE: user.ROLE,
          STATE: user.STATE === 'Y' ? 'Active' : 'Inactive',
          LEVEL: user.LEVEL === 'level 99' ? 'TEST' : user.LEVEL,
          DATE: user.REG_DTM,
          REFERRER_ID: user.REFERRER_ID,
        }))
        setUsersList(filteredData)
        setUsersList(buildUsersList(res.data))
        setCurrentPage(1)
      }
    } catch (err) {
      console.error('사용자 목록 가져오기 중 오류 발생:', err)
    }
  }

  const handleItemClick = (item, index) => {
    reset()
    const actualIndex = (currentPage - 1) * itemsPerPage + index
    const userData = detailUsersList[actualIndex]
    setSelectedUser(userData)
    console.log('userData?', userData)
    setEditForm({
      ID: userData.ID || '',
      USER_ID: userData.USER_ID || '',
      NAME: userData.NAME || '',
      PASSWORD: userData.PASSWORD || '',
      EMAIL: userData.EMAIL || '',
      PHONE: userData.PHONE || '',
      BIRTH: userData.BIRTH || '',
      ADDR: userData.ADDR || '',
      POSTCODE: userData.POSTCODE || '',
      CITY: userData.CITY || '',
      COUNTRY: userData.COUNTRY || '',
      SCHOOL: userData.SCHOOL || '',
      LEVEL: userData.LEVEL || '',
      LEVEL_ID: userData.LEVEL_ID || '',
      CENTER_ID: userData.CENTER_ID != null ? String(userData.CENTER_ID) : '',
      CENTER_NAME: userData.CENTER_NAME || '',
      PARENT_ID: userData.PARENT_ID || '',
      GUARDIAN_NAME: userData.GUARDIAN_NAME || '',
      GUARDIAN_EMAIL: userData.GUARDIAN_EMAIL || '',
      STATE: userData.STATE || '',
      STATUS: userData.STATUS || '',
      AVATAR: userData.AVATAR || '',
      TEST: userData.TEST || '',
      SUB: userData.SUB || '',
      REFERRER_ID: userData.REFERRER_ID || '',
    })
    setReportSavedAt(null)
    setIsDetailModalOpen(true)
  }

  const handleDetailModalClose = () => {
    setIsDetailModalOpen(false)
    setSelectedUser(null)
    resetEditForm()
  }

  const handleCenterNameChange = (value) => {
    setEditForm((prev) => ({
      ...prev,
      CENTER_NAME: value,
    }))
  }

  useEffect(() => {
    if (isSuccess) {
      notifications.show({
        title: 'Success',
        message: '사용자 정보가 수정되었습니다.',
        color: 'green',
      })
      fetchUsersList()
      handleDetailModalClose()
      reset()
    }
  }, [isSuccess])

  useEffect(() => {
    if (isError) {
      notifications.show({
        title: 'Error',
        message: 'An error occurred while updating',
        color: 'red',
      })
    }
  }, [isError])

  const handleUpdateUsers = async () => {
    modals.openConfirmModal({
      title: 'Edit Profile',
      children: 'Would you like to update the user information?',
      labels: { confirm: 'Edit', cancel: 'Cancel' },
      confirmProps: { color: 'blue' },
      onConfirm: async () => {
        const userData = {
          ID: editForm.ID,
          USER_ID: editForm.USER_ID,
          NAME: editForm.NAME,
          PASSWORD: editForm.PASSWORD,
          EMAIL: editForm.EMAIL,
          PHONE: editForm.PHONE,
          BIRTH: editForm.BIRTH,
          ADDR: editForm.ADDR,
          POSTCODE: editForm.POSTCODE,
          CITY: editForm.CITY,
          COUNTRY: editForm.COUNTRY,
          SCHOOL: editForm.SCHOOL,
          LEVEL: editForm.LEVEL !== '' ? Number(editForm.LEVEL) : 0,
          LEVEL_ID: editForm.LEVEL_ID !== '' ? Number(editForm.LEVEL_ID) : 0,
          CENTER_ID: editForm.CENTER_ID ? Number(editForm.CENTER_ID) : 0,
          CENTER_NAME: editForm.CENTER_NAME,
          PARENT_ID: editForm.PARENT_ID,
          GUARDIAN_NAME: editForm.GUARDIAN_NAME,
          GUARDIAN_EMAIL: editForm.GUARDIAN_EMAIL,
          STATE: editForm.STATE,
          SUB: editForm.SUB,
          TEST: editForm.TEST !== '' ? Number(editForm.TEST) : 0,
        }

        updateUser(userData)
      },
    })
  }

  const handleDeleteUsers = async () => {
    if (!selectedUser?.ID) {
      notifications.show({
        title: 'Error',
        message: '삭제할 사용자가 없습니다.',
        color: 'red',
      })
      return
    }

    modals.openConfirmModal({
      title: '사용자 삭제',
      children: (
        <div>
          <p>
            정말로 <strong>{selectedUser.NAME}</strong> 사용자를
            삭제하시겠습니까?
          </p>
        </div>
      ),
      labels: { confirm: '삭제', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        deleteUser(
          { ID: selectedUser.ID },
          {
            onSuccess: () => {
              notifications.show({
                title: 'Success',
                message: 'Deleted.',
                color: 'green',
              })
              fetchUsersList()
              handleDetailModalClose()
            },
            onError: (error) => {
              console.error('사용자 삭제 중 오류 발생:', error)
              notifications.show({
                title: 'Error',
                message: 'An error occurred while deleting.',
                color: 'red',
              })
            },
          }
        )
      },
    })
  }

  const handleAddUser = () => {
    setIsAddModalOpen(true)
  }

  const handleAddModalClose = () => {
    setIsAddModalOpen(false)
    fetchUsersList()
  }

  const handlePayUser = () => {
    // SUB === 'N' 만 타겟팅
    console.log('detailUsersList ? ', detailUsersList)
    const targets = detailUsersList.filter(
      (u) => u.SUB === 'N' && u.STATUS === 'U'
    )
    const getTotalUser = detailUsersList.filter((u) => u.STATUS === 'U')

    if (targets.length === 0) {
      notifications.show({
        title: 'No Unpaid Users',
        message: '모든 구독이 이미 결제되었습니다.',
        color: 'gray',
      })
      return
    }

    setPendingTargets(targets) // 결제 대상 저장
    setTotalUser(getTotalUser) // 전체 유저 수
    setSubCycle('M') // 기본값: 월 결제
    setIsSubModalOpen(true) // 월/년 선택 모달 열기
  }

  const handleGuardianAdd = (e) => {
    e.preventDefault()
    setGuardianModalOpen(true)
  }

  const handleGuardianEdit = (e) => {
    e.preventDefault()
    setGuardianEditModalOpen(true)
  }

  return (
    <div>
      <div className="uploads-search-section">
        <div className="search-section">
          {user?.STATUS === 'A' && (
            <MantineSelectBox
              value={CENTER_NAME}
              data={CENTER_DATA}
              onChange={setCENTER_NAME}
              width="200px"
            />
          )}
          <input
            className="search-input"
            placeholder="Name"
            value={NAME}
            onChange={(e) => setNAME(e.target.value)}
          />
          <input
            className="search-input"
            placeholder="Phone Number"
            value={PHONE}
            onChange={(e) => setPHONE(e.target.value)}
          />
          <MantineSelectBox
            value={STATE}
            data={stateData}
            onChange={setSTATE}
          />
        </div>
        <div className="search-buttons">
          <SaveButton
            onClick={() => {
              setCENTER_NAME('')
              setNAME('')
              setPHONE('')
              setSTATE('')
            }}
          >
            Reset
          </SaveButton>
          <SaveButton onClick={fetchUsersList}>Search</SaveButton>
        </div>
      </div>

      {user?.STATUS === 'M' && (
        <div className="addButtonWrapper">
          <BaseButton
            className="addButton"
            onClick={handlePayUser}
            disabled={isPaying}
            style={{ display: 'none' }}
          >
            {isPaying ? 'Processing…' : 'Pay All'}
          </BaseButton>
          <BaseButton className="addButtonLarge" onClick={handleAddUser}>
            Add
          </BaseButton>
        </div>
      )}

      {user?.STATUS === 'A' && (
        <div className="addButtonWrapper">
          <BaseButton
            className="addButton"
            onClick={handleExportCSV}
            disabled={isExporting}
          >
            {isExporting ? 'Exporting... 잠시만 기다려주세요' : 'Export CSV'}
          </BaseButton>
        </div>
      )}

      <List
        showCheckbox={false}
        headers={headers}
        data={getCurrentPageData()}
        onItemClick={handleItemClick}
        columnWidths={usersColumnWidths}
      />

      <div className={styles.paginationWrapper}>
        <Pagination
          value={currentPage}
          onChange={handlePageChange}
          total={totalPages}
          size="sm"
          withEdges={false}
          color="gray"
          classNames={{
            control: styles.paginationControl,
          }}
        />
      </div>

      <div className="users-select-wrapper">
        <Select
          styles={{ input: { width: '150px', height: '40px' } }}
          data={['10entries', '20entries', '50entries']}
          value={`${itemsPerPage}entries`}
          onChange={handleItemsPerPageChange}
        />
      </div>

      <AddUserModal opened={isAddModalOpen} onClose={handleAddModalClose} />

      {/* 사용자 상제 모달 */}
      <Modal
        opened={isDetailModalOpen}
        onClose={handleDetailModalClose}
        size="xl"
        padding=""
        styles={{
          content: {
            borderRadius: '15px',
          },
          close: {
            top: '-20px',
            right: '10px',
          },
        }}
      >
        {selectedUser && (
          <form>
            <div className="modal-content">
              <div className="top-wrapper">
                <div className="user-info-wrapper">
                  <div className="user-info-inner-wrapper">
                    <div className="avatar">
                      {editForm.AVATAR ? (
                        <img
                          src={editForm.AVATAR}
                          alt="사용자 아바타"
                          className="avatar-image"
                        />
                      ) : (
                        <div className="avatar-placeholder"><img src="/assets/icons/user.png" alt="user" style={{ width: 24, height: 24, objectFit: 'contain' }} /></div>
                      )}
                    </div>
                    <div className="user-form-wrapper">
                      <div className="form-group">
                        <label className="text-lg">User name</label>
                        <input
                          type="text"
                          value={editForm.NAME}
                          placeholder="이름을 입력하세요"
                          disabled
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-lg">Email Address</label>
                        <input
                          type="email"
                          value={editForm.EMAIL}
                          placeholder="Enter email"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="level-info-wrapper">
                  <div className="level-header-wrapper">
                    <Icon name="info" size={20} />
                    <p className="text-lg">Level Info</p>
                  </div>
                  <div className="level-inputs-wrapper">
                    <div className="level-input-item">
                      <p className="text-sm input-label">Level</p>
                      {user?.STATUS === 'A' ? (
                        <input
                          type="number"
                          value={editForm.LEVEL_ID}
                          onChange={(e) =>
                            handleInputChange('LEVEL_ID', e.target.value)
                          }
                        />
                      ) : (
                        <span>{editForm.LEVEL_ID}</span>
                      )}
                    </div>
                    <div className="level-input-item">
                      <p className="text-sm input-label">ROLE</p>
                      <input
                        type="text"
                        value={roleLabel(editForm.STATUS)}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="general-info-wrapper">
                <div className="general-info-header-wrapper">
                  <Icon name="info" size={20} />
                  <p className="text-lg">General Information</p>
                </div>

                <div className="general-info-fields-wrapper">
                  <div className="field-item">
                    <p className="text-sm input-label">ID</p>
                    <input
                      type="text"
                      value={editForm.ID}
                      autoComplete="username"
                      disabled
                    />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">User ID</p>
                    <input
                      type="text"
                      value={editForm.USER_ID}
                      autoComplete="username"
                      disabled
                    />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">Password</p>
                    <input
                      type="password"
                      value={editForm.PASSWORD}
                      autoComplete="new-password"
                      onChange={(e) => handleInputChange('PASSWORD', e.target.value)}
                    />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">Date of birth</p>
                    <input type="date" value={editForm.BIRTH} disabled />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">Phone</p>
                    <input
                      type="text"
                      value={editForm.PHONE}
                      onChange={(e) => handleInputChange('PHONE', e.target.value)}
                    />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">School</p>
                    <input
                      type="text"
                      value={editForm.SCHOOL}
                      onChange={(e) => handleInputChange('SCHOOL', e.target.value)}
                    />
                  </div>

                  <div className="divider"></div>

                  <div className="field-item">
                    <p className="text-sm input-label">Country</p>
                    <MantineSelectBox
                      value={editForm.COUNTRY}
                      data={countries}
                      placeholder="Select country"
                      width="200px"
                      disabled
                    />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">City</p>
                    <input
                      type="text"
                      value={editForm.CITY}
                      placeholder="City"
                      disabled
                    />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">Postcode</p>
                    <input
                      type="text"
                      value={editForm.POSTCODE}
                      placeholder="Postal Code"
                      disabled
                    />
                  </div>

                  <div className="full-width-field">
                    <p className="text-sm input-label">Address</p>
                    <input
                      type="text"
                      value={editForm.ADDR}
                      placeholder="Enter address"
                      onChange={(e) => handleInputChange('ADDR', e.target.value)}
                    />
                  </div>

                  <div className="field-item">
                    <p className="text-sm input-label">Center</p>
                    <MantineSelectBox
                      key={selectedUser?.ID ?? 'new'}
                      value={editForm.CENTER_ID ?? ''}
                      onChange={(value) =>
                        setEditForm((prev) => ({
                          ...prev,
                          CENTER_ID: value ?? '',
                        }))
                      }
                      data={CENTER_DATA}
                      placeholder="센터를 선택해주세요"
                      width="200px"
                    />

                    <p className="text-sm input-label">Subscribe</p>
                    {user?.STATUS === 'A' ? (
                      <MantineSelectBox
                        value={editForm.SUB}
                        onChange={(value) =>
                          setEditForm((prev) => ({ ...prev, SUB: value }))
                        }
                        data={SUB_DATA}
                        width="200px"
                      />
                    ) : (
                      <MantineSelectBox
                        value={editForm.SUB}
                        onChange={(value) =>
                          setEditForm((prev) => ({ ...prev, SUB: value }))
                        }
                        data={SUB_DATA}
                        width="200px"
                        disabled
                      />
                    )}
                  </div>
                </div>
                  <div className="field-item">
                    <p className="text-sm input-label">REFERRER</p>
                    <input
                      type="text"
                      value={editForm.REFERRER_ID}
                      disabled
                    />
                  </div>
              </div>



              <div className="bottom-wrapper">
                {hasGardianInfo() ? (
                  <div className="guardian-wrapper">
                    <div className="guardian-header-wrapper">
                      <Icon name="info" size={20} />
                      <p className="text-lg">Guardian info</p>
                    </div>

                    <div className="guardian-fields">
                      <div className="field-item">
                        <p className="text-sm input-label">ID</p>
                        <input
                          type="text"
                          value={editForm.ID}
                          disabled
                        />
                      </div>

                      <div className="field-item">
                        <p className="text-sm input-label">Name</p>
                        <input
                          type="text"
                          value={editForm.GUARDIAN_NAME}
                          disabled
                        />
                      </div>

                      <div className="field-item">
                        <p className="text-sm input-label">Email</p>
                        <input
                          type="email"
                          value={editForm.GUARDIAN_EMAIL}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="usersbox-button-wrapper">
                      <SaveButton onClick={handleGuardianEdit}>수정</SaveButton>
                    </div>
                  </div>
                ) : (
                  <div className="guardian-wrapper">
                    <div className="guardian-header-wrapper">
                      <Icon name="info" size={20} />
                      <p className="text-lg">Guardian info</p>
                    </div>

                    <div className="usersbox-button-wrapper">
                      <SaveButton onClick={handleGuardianAdd}>
                        Add Guardian
                      </SaveButton>
                    </div>
                  </div>
                )}
                <div className="status-wrapper">
                  <div className="status-header-wrapper">
                    <Icon name="info" size={20} />
                    <p className="text-lg">Status</p>
                  </div>
                  <div className="status-buttons-wrapper">
                    <button
                      className={`status-button ${
                        editForm.STATE === 'Y'
                          ? 'active-button'
                          : 'active-button-outline'
                      }`}
                    >
                      Active
                    </button>
                    <button
                      className={`status-button ${
                        editForm.STATE === 'N'
                          ? 'inactive-button'
                          : 'inactive-button-outline'
                      }`}
                    >
                      Inactive
                    </button>
                  </div>
                </div>
              </div>

              <div className="button-wrapper">
                {user?.STATUS === 'A' && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                      padding: '0 10px',
                      height: 36,
                      border: '1px solid #D0D5DD',
                      borderRadius: 8,
                      background: '#fff',
                      fontSize: 13,
                      color: '#344054',
                    }}>
                      <span style={{ fontSize: 13, color: '#98A2B3', marginRight: 2 }}>📅</span>
                      <select
                        value={reportMonth.split('-')[0]}
                        onChange={e => {
                          const newYear = e.target.value
                          const curYear = new Date().getFullYear()
                          const curMonth = new Date().getMonth() + 1
                          const selMonth = parseInt(reportMonth.split('-')[1], 10)
                          const maxMonth = parseInt(newYear, 10) === curYear ? curMonth - 1 : 12
                          const clampedMonth = Math.min(selMonth, maxMonth < 1 ? 1 : maxMonth)
                          setReportMonth(`${newYear}-${String(clampedMonth).padStart(2,'0')}`)
                        }}
                        style={{ border: 'none', outline: 'none', fontSize: 13, color: '#344054', background: 'transparent', cursor: 'pointer' }}
                      >
                        {Array.from({ length: 2 }, (_, i) => new Date().getFullYear() - i).map(y => (
                          <option key={y} value={y}>{y}</option>
                        ))}
                      </select>
                      <span style={{ color: '#D0D5DD', margin: '0 2px' }}>/</span>
                      <select
                        value={reportMonth.split('-')[1]}
                        onChange={e => setReportMonth(`${reportMonth.split('-')[0]}-${e.target.value}`)}
                        style={{ border: 'none', outline: 'none', fontSize: 13, color: '#344054', background: 'transparent', cursor: 'pointer' }}
                      >
                        {(() => {
                          const all = [
                            ['01','Jan'],['02','Feb'],['03','Mar'],['04','Apr'],
                            ['05','May'],['06','Jun'],['07','Jul'],['08','Aug'],
                            ['09','Sep'],['10','Oct'],['11','Nov'],['12','Dec'],
                          ]
                          const selYear = parseInt(reportMonth.split('-')[0], 10)
                          const curYear = new Date().getFullYear()
                          const curMonth = new Date().getMonth() + 1
                          const maxMonth = selYear === curYear ? curMonth - 1 : 12
                          return all.filter((_, i) => i + 1 <= maxMonth)
                        })().map(([val, label]) => (
                          <option key={val} value={val}>{label}</option>
                        ))}
                      </select>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
                      <SaveButton
                        type="button"
                        onClick={handleGenerateReport}
                        disabled={isGeneratingReport}
                      >
                        {isGeneratingReport ? 'Generating...' : 'Generate Report'}
                      </SaveButton>
                      {reportSavedAt && (
                        <span style={{ fontSize: 11, color: '#98A2B3' }}>
                          저장: {new Date(reportSavedAt).toLocaleString('ko-KR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <SaveButton type="button" onClick={handleUpdateUsers}>
                  Save
                </SaveButton>
                <SaveButton type="button" onClick={handleDeleteUsers}>
                  Delete
                </SaveButton>
              </div>
            </div>
          </form>
        )}
      </Modal>
      <Modal
        opened={isSubModalOpen}
        onClose={() => setIsSubModalOpen(false)}
        title="Subscription Payment"
        size="md"
      >
        <div className="modal-content">
          <div className="form-group">
            <label>Billing Cycle</label>
            <MantineSelectBox
              value={subCycle}
              onChange={setSubCycle}
              data={[{ value: 'M', label: 'Monthly ($20 / seat)' }]}
              placeholder="Choose billing cycle"
              width="100%"
            />
            <div style={{ marginTop: 12, fontSize: 14, lineHeight: 1.6 }}>
              <div>
                Total users (after pay): <b>{totalUsers}</b>
              </div>
              <div>
                Seats to pay (unpaid): <b>{unpaidCount}</b>
              </div>
              <div>
                List Unit Price: <b>$20.00</b>
              </div>
              <div>
                Blended Unit (tiered):{' '}
                <b>${overallTotalIfAllPaid.toFixed(2)}</b>
              </div>
              <div style={{ marginTop: 6 }}>
                Base: <s>${base.toFixed(2)}</s> &nbsp; Discount:{' '}
                <b>-${discountAmt.toFixed(2)}</b>
              </div>
              <div>
                Total (this payment):{' '}
                <b>
                  $
                  {subTotal.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </b>
              </div>
            </div>
          </div>

          <div className="button-wrapper">
            <SaveButton onClick={() => setIsSubModalOpen(false)}>
              Cancel
            </SaveButton>
            <SaveButton
              onClick={() => {
                if (unpaidCount < 1) {
                  notifications.show({
                    title: 'No Seats',
                    message: '미결제 사용자가 없습니다.',
                    color: 'yellow',
                  })
                  return
                }
                setIsSubModalOpen(false)
                setShowPayPalSub(true) // PayPal 오버레이 열기
              }}
            >
              Checkout
            </SaveButton>
          </div>
        </div>
      </Modal>

      {showPayPalSub && (
        <div
          style={{
            zIndex: 9999,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              width: '100%',
              maxWidth: '450px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                padding: '16px 24px',
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <h5 style={{ margin: 0 }}>PayPal</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                style={{ padding: '10px' }}
                onClick={() => setShowPayPalSub(false)}
              />
            </div>
            <div
              style={{ padding: '20px', height: '500px', overflowY: 'auto' }}
            >
              <PayPalCheckout
                amount={String(subTotal.toFixed(2))}
                onApprove={async () => {
                  setIsPaying(true)
                  try {
                    // 1) 주문 기록
                    try {
                      const effectiveDiscountRate =
                        base > 0 ? Number((1 - subTotal / base).toFixed(4)) : 0
                      await apiRequest('/orders/subscription', 'POST', {
                        cycle: subCycle,
                        seats: unpaidCount,
                        unit_price: subUnit,
                        discount_rate: effectiveDiscountRate, // 평균 할인율
                        effective_unit_price: overallTotalIfAllPaid, // 평균 단가
                        total_price: subTotal,
                        total_users: totalUsers,
                        center_id: CENTER_NAME,
                        buyer: user?.USER_ID || 'Guest',
                        currency: 'USD',
                        // 원하면 브레이크다운도 기록 가능
                        breakdown,
                      })
                    } catch (e) {
                      console.warn('order log failed', e)
                    }

                    // 2) 구독 상태 일괄 업데이트
                    let successIds = []
                    try {
                      const bulkRes = await apiRequest(
                        '/subscriptions/pay-bulk',
                        'POST',
                        {
                          cycle: subCycle,
                          users: pendingTargets.map((u) => ({
                            ID: u.ID,
                            USER_ID: u.USER_ID,
                          })),
                        }
                      )
                      if (bulkRes?.success) {
                        successIds =
                          bulkRes.data?.successIds ??
                          pendingTargets.map((u) => u.ID)
                      } else {
                        throw new Error('bulk endpoint not available')
                      }
                    } catch (e) {
                      // 폴백: 개별 호출
                      const results = await Promise.allSettled(
                        pendingTargets.map((u) =>
                          apiRequest('/subscriptions/pay', 'POST', {
                            ID: u.ID,
                            USER_ID: u.USER_ID,
                            cycle: subCycle,
                          })
                        )
                      )
                      successIds = results.reduce((acc, r, idx) => {
                        if (
                          r.status === 'fulfilled' &&
                          (r.value?.success === true ||
                            r.value?.success === 'Y')
                        ) {
                          acc.push(pendingTargets[idx].ID)
                        }
                        return acc
                      }, [])
                    }

                    // 3) 로컬 리스트 갱신
                    if (successIds.length > 0) {
                      setDetailUsersList((prev) => {
                        const updated = prev.map((u) =>
                          successIds.includes(u.ID) ? { ...u, SUB: 'Y' } : u
                        )
                        setUsersList(buildUsersList(updated))
                        return updated
                      })
                    }

                    const failCount = unpaidCount - successIds.length
                    notifications.show({
                      title: 'Payment Completed',
                      message: `Seats: ${unpaidCount} • ${
                        subCycle === 'M' ? 'Monthly' : 'Yearly'
                      } • Success: ${successIds.length}${
                        failCount > 0 ? `, Fail: ${failCount}` : ''
                      }`,
                      color: 'green',
                    })
                  } catch (err) {
                    console.error('bulk subscription update failed:', err)
                    notifications.show({
                      title: 'Error',
                      message: '구독 상태 업데이트 중 오류가 발생했습니다.',
                      color: 'red',
                    })
                  } finally {
                    setIsPaying(false)
                    setShowPayPalSub(false)
                    setPendingTargets([])
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}

      <GuardianInfoModal
        opened={isGuardianModalOpen}
        onClose={() => setGuardianModalOpen(false)}
        studentInfo={editForm.ID}
        onSave={(guardian) => {
          setEditForm(prev => ({
            ...prev,
            GUARDIAN_NAME: guardian.name,
            GUARDIAN_EMAIL: guardian.email,
            PARENT_ID: guardian.id,
          }))
        }}
      />

      <GuardianEditModal
        opened={isGuardianEditModalOpen}
        onClose={() => setGuardianEditModalOpen(false)}
        onSave={(updatedGuardian) => {
          setEditForm(prev => ({
            ...prev,
            GUARDIAN_NAME: updatedGuardian.GUARDIAN_NAME,
            GUARDIAN_EMAIL: updatedGuardian.GUARDIAN_EMAIL,
            PARENT_ID: updatedGuardian.PARENT_ID,
          }));
          setGuardianEditModalOpen(false);
        }}
        studentInfo={{
          id: editForm.ID,
          name: editForm.NAME,
          email: editForm.EMAIL,
        }}
        guardianData={{
          PARENT_ID: editForm.PARENT_ID,
          GUARDIAN_NAME: editForm.GUARDIAN_NAME,
          GUARDIAN_EMAIL: editForm.GUARDIAN_EMAIL,
        }}
        parentId={editForm?.PARENT_ID}
        isEditMode={true}
      />
    </div>
  )
}

export default UsersBox
